<div class="modal001" [ngClass]="closeModalSearch ? 'fadeOut' : ''">
	<div class="modal001__wrapper">
		<div class="modal001__close">
			<i class="modal001__close__icon tagmeicon tagmeicon-close" (click)="closeModal()"></i>
		</div>
		<ng-content select="[content]"></ng-content>
	</div>
</div>
